import script from "./ProductCardItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductCardItem.vue?vue&type=script&setup=true&lang=ts"

import "./ProductCardItem.vue?vue&type=style&index=0&id=2b156aa6&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b156aa6"]])

export default __exports__